
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses/email-marketing-visuals",
      function () {
        return require("private-next-pages/for-businesses/email-marketing-visuals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-businesses/email-marketing-visuals"])
      });
    }
  